import React, { Component } from 'react';

import { connect } from 'react-redux';
import * as MapSearch from './Saga/MapSearch';

import '../../Css/GridRooms.css';
import moment from 'moment';

import { Table, Column, Cell } from 'fixed-data-table-2';
import 'fixed-data-table-2/dist/fixed-data-table.css';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';


// 文字列をタイムスタンプに変換（空文字や null → 0、Date.parse に失敗して NaN → 0）
function parseDate(str) {
  if (!str) return 0;
  const t = Date.parse(str);
  return isNaN(t) ? 0 : t;
}

function mise(l2){

  var l = {...l2}
  // 今日日付の00:00を取得
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const now = today.getTime();

  // 管理とサブのみ
  if(l.kanri_kubun_no == 1 || l.kanri_kubun_no == 4){
  }else{
    return false
  }

    // wrap があれば優先値を上書き
  if (l.wrap_id) {
    l.kaiyaku_date         = l.wrap_kaiyaku_date;//●
    l.taikyo_yotei_date    = l.wrap_taikyo_yotei_date;//●
    l.hoshuu_date          = l.wrap_hoshuu_date;//●
    l.comp                 = l.wrap_completion_at;
    l.kagiban_setti_date   = l.wrap_kagiban_setti_date;//●
  }
// alert(l.room_name)
  // 2-1. comp があり Kaiyaku_Date より前なら短縮
  if (l.comp && parseDate(l.kaiyaku_date) > parseDate(l.comp)) {
    l.kaiyaku_date = l.comp;
  }

  // 2-2. Kaiyaku > Io_Keiyaku → 空に
  if (parseDate(l.kaiyaku_date) > parseDate(l.io_keiyaku_date)) {
    l.io_keiyaku_date = '';
  }

  // 2-3. Io_Keiyaku_Date 空なら Tenpo_Name も空に
  if (!l.io_keiyaku_date) {
    l.Tenpo_Name = '';
  }

  // 2-6. Kaiyaku > Hoshuu → Hoshuu_Date を空に
  if (parseDate(l.kaiyaku_date) > parseDate(l.hoshuu_date)) {
    l.hoshuu_date = '';
  }

  // 2-7. 差が10日超なら completion_at を空に
  if (l.completion_at && parseDate(l.kaiyaku_date) > parseDate(l.completion_at)) {
    const termDay = (parseDate(l.kaiyaku_date) - parseDate(l.completion_at)) / 86400000;
    if (termDay > 10) {
      l.completion_at = '';
    }
  }

  // 2-2 の再適用（PHP のコード上、重複していた処理）
  if (parseDate(l.kaiyaku_date) > parseDate(l.io_keiyaku_date)) {
    l.io_keiyaku_date = '';
  }

  // 2-x. Kaiyaku > Kagiban_Setti && 通知日 > 設置日 → 空に
  if (
    parseDate(l.kaiyaku_date) > parseDate(l.kagiban_setti_date) &&
    parseDate(l.kaiyaku_tsuuchi_date) > parseDate(l.kagiban_setti_date)
  ) {
    l.kagiban_setti_date = '';
  }
// alert(l.room_name)
  // 2-4. (解約 > 設置) && (鍵受取なし or 鍵受取 > 設置) → 設置日を空に
  if (
    parseDate(l.kaiyaku_date) > parseDate(l.kagiban_setti_date) &&
    (!l.kagi_uketori_date || parseDate(l.kagi_uketori_date) > parseDate(l.kagiban_setti_date))
  ) {
    l.kagiban_setti_date = '';
  }

  // 2-5. Io_Keiyaku_Date が未来日なら pre_kagiban_setti_date に戻す
  if (l.io_keiyaku_date && parseDate(l.io_keiyaku_date) > now) {
    l.kagiban_setti_date = l.pre_kagiban_setti_date || l.kagiban_setti_date;
  }

  // 2-8. Kagiban_Tekkyo_Date 無 or 解約 > 撤去 → 空に
  if (!l.kagiban_tekkyo_date || parseDate(l.kaiyaku_date) > parseDate(l.kagiban_tekkyo_date)) {
    l.kagiban_tekkyo_date = '';
  }

  // 2025-07-24 修正：JS の is_m 判定と完全同期
  if ([1, 2, 3].includes(l.kuushitsu_joukyou_no)) {

    // 事前準備: nkDate を「今日」にセット
    let nkDate = now;
    if (!l.kaiyaku_date) {
      if (!l.completion_at) {
        // 日付を「上8日／中18日／下28日」に丸め
        let nkDay = l.nyuukyo_kanou_day;
        if (nkDay === '上旬') nkDay = 8;
        else if (nkDay === '中旬') nkDay = 18;
        else if (nkDay === '下旬') nkDay = 28;
        nkDate = new Date(`${l.nyuukyo_kanou_year}/${l.nyuukyo_kanou_month}/${nkDay}`).getTime();
      } else {
        // completion_at がある場合は「見せ部屋対象外」
        nkDate = now + 86400000;
      }
    }


    // 見せ部屋 (is_m) 判定
    if (
        (!l.kaiyaku_date && nkDate <= now) ||
        (
          l.kagiban_setti_date &&
          parseDate(l.kagiban_setti_date) <= now && 
          parseDate(l.kaiyaku_tsuuchi_date) < parseDate(l.kagiban_setti_date)
        ) ||

        (

          (l.Kaiyaku_Date < now) &&
          (l.kagiban_setti_date != '' && l.kagiban_setti_date != null && l.kagiban_setti_date <= now) &&
          (l.io_keiyaku_date == '' || l.io_keiyaku_date == null || l.io_keiyaku_date > now)

        ) ||

        (

          (l.Kaiyaku_Date < now) &&
          (l.kagiban_setti_date == '' || l.kagiban_setti_date == null ) &&
          (l.io_keiyaku_date != '' && l.io_keiyaku_date != null && l.io_keiyaku_date > now)

        )

    ) {
      return true
    }
    
  }

  return false
  }

  // // 入居可能状況が募集停止、家主使用、未補修、入居中以外
  // if(row.kuushitsu_joukyou_no == 6 || row.kuushitsu_joukyou_no == 100 || row.kuushitsu_joukyou_no == 101 || row.kuushitsu_joukyou_no == 4){
  //   return false
  // }

  // // 鍵番設置日が今日より未来なら見れない。
  // if(row.kagiban_setti_date){
  //   // if(moment(row.io_keiyaku_date) > moment(row.kagiban_setti_date)){
  //     if(moment(row.kagiban_setti_date).format("YYYYMMDD") >= moment().format("YYYYMMDD")){
  //       return false
  //     }
  // // } else {
    
  // // } 
  // }


  // // if(row.room_name == "B101"){
  // //   alert(row.io_keiyaku_date)
  // //   alert(row.kaiyaku_date)
  // // }
  

  // let keiyakumae = false
  // // 契約日がない場合OK
  // // 
  // if(row.io_keiyaku_date){
  //   if(moment(row.io_keiyaku_date).format("YYYYMMDD") < moment(row.kaiyaku_date).format("YYYYMMDD")) {
  //     keiyakumae = true
  //   }else{
  //     // 次の契約が決まってて、契約日は今日より未来
  //     if (moment(row.io_keiyaku_date).format("YYYYMMDD") > moment().format("YYYYMMDD")) {
  //       keiyakumae = true
  //     }
  //   }
  // }else{
  //   keiyakumae = true
  // }
  // if (!keiyakumae) return false
  
  // // 鍵番撤去日が入ってて
  // if(row.kagiban_tekkyo_date){
  //   if(row.kaiyaku_date) {
  //     if(moment(row.kaiyaku_date).format("YYYYMMDD") < moment(row.kagiban_tekkyo_date).format("YYYYMMDD")){
  //     // 撤去日が解約日より未来で、撤去日が今日より過去
  //       if(moment(row.kagiban_tekkyo_date).format("YYYYMMDD") <= moment().format("YYYYMMDD")){
  //         return false
  //       }
  //     }
  //   }else{
  //     // 撤去日が今日より過去
  //     if(moment(row.kagiban_tekkyo_date).format("YYYYMMDD") <= moment().format("YYYYMMDD")){
  //       return false
  //     }
  //   }
  // }
  


  // let nyuukyo_kanou

  // if(row.nyuukyo_kanou_year == "" || row.nyuukyo_kanou_year  == "-" || row.nyuukyo_kanou_month == "" || row.nyuukyo_kanou_month == "-" || row.nyuukyo_kanou_day == "" || row.nyuukyo_kanou_day == "-"){
  //   nyuukyo_kanou = ""
  // }else{
  //   nyuukyo_kanou = row.nyuukyo_kanou_year+row.nyuukyo_kanou_month+row.nyuukyo_kanou_day.replace("上旬","08").replace("中旬","18").replace("下旬","28")
  // }

  // // alert(row.kaiyaku_date)
  // // alert(row.room_name)
  // // 解約日がない
  // if(!row.kaiyaku_date){
  //   // 入居可能日が過ぎている。
  //   if(nyuukyo_kanou){
  //     if(moment(nyuukyo_kanou).format("YYYYMMDD") < moment().format("YYYYMMDD")){
  //       return true
  //     }
  //   }
  // }else{
  //   // 完工日を過ぎている。
  //   if(row.completion_at && moment(row.completion_at).format("YYYYMMDD") < moment().format("YYYYMMDD")){
  //     return true
  //   }
  //   // 解約日を過ぎている。
  //   if(moment(row.kaiyaku_date).format("YYYYMMDD") < moment().format("YYYYMMDD")){
  //     if(moment(row.kagiban_setti_date).format("YYYYMMDD") < moment().format("YYYYMMDD")){
  //       return true
  //     }
  //   }
  //   // 鍵番設置日を過ぎている。
  //   if(moment(row.kagiban_setti_date).format("YYYYMMDD") < moment().format("YYYYMMDD")){
  //     return true
  //   }
  // }
  
  // return false
  




function RoomName ({ column, props, rowIndex }){
  return <Cell style={{whiteSpace: "nowrap", width: "100%", height: "100%", borderTop: "1px solid  #9c9c9c", background: mise(props.map_room_details_all[rowIndex]) ? "#fff396" : ""}} >
    {props.map_room_details_all[rowIndex].room_name}[{props.map_room_details_all[rowIndex].madori_name}]({props.map_room_details_all[rowIndex].kanri_kubun_name})</Cell>;
}
const KuushitsuJoukyou = ({ column, props, rowIndex }) =>
  <Cell style={{whiteSpace: "nowrap", width: "100%", height: "100%", borderTop: "1px solid  #9c9c9c", background: mise(props.map_room_details_all[rowIndex]) ? "#fff396" : ""}} >
    {props.map_room_details_all[rowIndex].kuushitsu_joukyou_name}
    </Cell>;

const KaiyakuDate = ({ column, props, rowIndex }) =>
  <Cell style={{whiteSpace: "nowrap", width: "100%", height: "100%", borderTop: "1px solid  #9c9c9c", background: mise(props.map_room_details_all[rowIndex]) ? "#fff396" : ""}} >
    {props.map_room_details_all[rowIndex].kaiyaku_date ? moment(props.map_room_details_all[rowIndex].kaiyaku_date).format("YYYY/MM/DD") : ""}
    </Cell>;

const KagibanSettiDate = ({ column, props, rowIndex }) =>
  <Cell style={{whiteSpace: "nowrap", width: "100%", height: "100%", borderTop: "1px solid  #9c9c9c", background: mise(props.map_room_details_all[rowIndex]) ? "#fff396" : ""}} >
    {props.map_room_details_all[rowIndex].kagiban_setti_date ? moment(props.map_room_details_all[rowIndex].kagiban_setti_date).format("YYYY/MM/DD") : ""}
    </Cell>;

const HoshuuDate = ({ column, props, rowIndex }) =>
  <Cell style={{whiteSpace: "nowrap", width: "100%", height: "100%", borderTop: "1px solid  #9c9c9c", background: mise(props.map_room_details_all[rowIndex]) ? "#fff396" : ""}} >
    {props.map_room_details_all[rowIndex].hoshuu_date ? moment(props.map_room_details_all[rowIndex].hoshuu_date).format("YYYY/MM/DD") : ""}
    </Cell>;

const CompletionAt = ({ column, props, rowIndex }) =>
  <Cell style={{whiteSpace: "nowrap", width: "100%", height: "100%", borderTop: "1px solid  #9c9c9c", background: mise(props.map_room_details_all[rowIndex]) ? "#fff396" : ""}} >
    {props.map_room_details_all[rowIndex].completion_at ? 
      props.map_room_details_all[rowIndex].kaiyaku_date && moment(props.map_room_details_all[rowIndex].completion_at) < moment(props.map_room_details_all[rowIndex].kaiyaku_date) ? "" : moment(props.map_room_details_all[rowIndex].completion_at).format("YYYY/MM/DD") : ""}
    </Cell>;

const KagibanTekkyoDate = ({ column, props, rowIndex }) =>
  <Cell style={{whiteSpace: "nowrap", width: "100%", height: "100%", borderTop: "1px solid  #9c9c9c", background: mise(props.map_room_details_all[rowIndex]) ? "#fff396" : ""}} >
    {props.map_room_details_all[rowIndex].kagiban_tekkyo_date ? props.map_room_details_all[rowIndex].kaiyaku_date ? moment(props.map_room_details_all[rowIndex].kaiyaku_date).format("YYYY/MM/DD") < moment(props.map_room_details_all[rowIndex].kagiban_tekkyo_date).format("YYYY/MM/DD") ? moment(props.map_room_details_all[rowIndex].kagiban_tekkyo_date).format("YYYY/MM/DD") : "" : moment(props.map_room_details_all[rowIndex].kagiban_tekkyo_date).format("YYYY/MM/DD") : ""}
    </Cell>;

const IoKeiyakuDate = ({ column, props, rowIndex }) =>
  <Cell style={{whiteSpace: "nowrap", width: "100%", height: "100%", borderTop: "1px solid  #9c9c9c", background: mise(props.map_room_details_all[rowIndex]) ? "#fff396" : ""}} >
    {props.map_room_details_all[rowIndex].io_keiyaku_date ? props.map_room_details_all[rowIndex].kaiyaku_date && (moment(props.map_room_details_all[rowIndex].io_keiyaku_date).format("YYYY/MM/DD") < moment(props.map_room_details_all[rowIndex].kaiyaku_date).format("YYYY/MM/DD")) ? "" : moment(props.map_room_details_all[rowIndex].io_keiyaku_date).format("YYYY/MM/DD") : ""}
    </Cell>;

const TantouTenpo = ({ column, props, rowIndex }) =>
<Cell style={{whiteSpace: "nowrap", width: "100%", height: "100%", borderTop: "1px solid  #9c9c9c", background: mise(props.map_room_details_all[rowIndex]) ? "#fff396" : ""}} >
    {props.map_room_details_all[rowIndex].io_keiyaku_date ? props.map_room_details_all[rowIndex].kaiyaku_date && (moment(props.map_room_details_all[rowIndex].io_keiyaku_date).format("YYYY/MM/DD") < moment(props.map_room_details_all[rowIndex].kaiyaku_date).format("YYYY/MM/DD")) ? "" : props.map_room_details_all[rowIndex].tenpo_name_short : ""}
    </Cell>;

const Detail = ({ column, props, rowIndex }) =>
  <Cell style={{whiteSpace: "nowrap", width: "100%", height: "100%", borderTop: "1px solid  #9c9c9c", background: mise(props.map_room_details_all[rowIndex]) ? "#fff396" : ""}} >
    </Cell>;


const columns =
[
  {key: 'room_name', name:'部屋名', width: 150, resizeable:true},
  {key: 'kuushitsu_joukyou_name', name:'空状況', width: 110, resizeable:true},
  {key: 'kaiyaku_date', name:'解約日', width: 110, resizeable:true},
  {key: 'kagiban_setti_date', name:'鍵番設置', width: 110, resizeable:true},
  {key: 'hoshuu_date', name:'完工予定', width: 110, resizeable:true},
  {key: 'completion_at', name:'完工日', width: 110, resizeable:true},
  {key: 'kagiban_tekkyo_date', name:'鍵番撤去', width: 110, resizeable:true},
  {key: 'io_keiyaku_date', name:'契約日', width: 110, resizeable:true},
  {key: 'tenpo_name_short', name:'担当店舗', width: 110, resizeable:true},
]

var SortTypes = {
  ASC: 'ASC',
  DESC: 'DESC',
};

function reverseSortDirection(sortDir) {
  return sortDir === SortTypes.DESC ? SortTypes.ASC : SortTypes.DESC;
}
class SortHeaderCell extends React.Component {
  constructor(props) {
    super(props);

    this._onSortChange = this._onSortChange.bind(this);
  }

  render() {
    var { onSortChange, sortDir, children, ...props } = this.props;
    return (
      <Cell {...props} onClick={this._onSortChange}>

        {children} {sortDir ? (sortDir === SortTypes.DESC ? <ArrowDropDownIcon /> : <ArrowDropUpIcon />) : ''}

      </Cell>
    );
  }

  _onSortChange(e) {

    e.preventDefault();

    if (this.props.onSortChange) {
      this.props.onSortChange(
        this.props.columnKey,
        this.props.sortDir ?
          reverseSortDirection(this.props.sortDir) :
          SortTypes.DESC
      );
    }
  }
}






class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      columns: columns,
      reflesh: false,
      colSortDirs: {},
    };

    this._onColumnResizeEndCallback = this._onColumnResizeEndCallback.bind(this);
    this._onSortChange = this._onSortChange.bind(this);

  }
  

  _onColumnResizeEndCallback(newColumnWidth, columnKey) {

    let columnsset = columns.map(function (value) {
      if (value.key === columnKey) {
        value.width = newColumnWidth
      }
      return value
    })

    this.setState({ columns: columnsset })

  }

  _onSortChange(columnKey, sortDir) {

    let map_room_details_all = this.props.map_room_details_all;

    map_room_details_all.sort((indexA, indexB) => {
      // alert(indexA)

      var valueA = indexA[columnKey];
      var valueB = indexB[columnKey];
      var sortVal = 0;
      if (valueA > valueB) {
        sortVal = 1;
      }
      if (valueA < valueB) {
        sortVal = -1;
      }

      if (!valueA && !valueB) {
        sortVal = 0
      }
      if (!valueA) {
        sortVal = -1
      }
      if (!valueB) {
        sortVal = 1
      }


      if (sortVal !== 0 && sortDir === SortTypes.DESC) {
        sortVal = sortVal * -1;
      }

      return sortVal;
    });
    this.props.change_map_room_details_all(map_room_details_all)
    this.setState({
      // sortedDataList: new DataListWrapper(sortIndexes, this._dataList),
      colSortDirs: {
        [columnKey]: sortDir,
      },
    });
  }

  // }

  render() {
    //     // console.log(this.props.customerlists)
    //     // alert(this.props.customerlists+"sss")
    //     // const ss:any=[];
    return (
      <div>

        <Table
          className='showRoomList'
          rowHeight={28}
          rowsCount={this.props.map_room_details_all.length}
          onColumnResizeEndCallback={this._onColumnResizeEndCallback}
          isColumnResizing={false}
          touchScrollEnabled={true}
          width={window.innerWidth - 110}
          height={window.innerHeight - 250}
          headerHeight={20}>

          {columns.map(function (value, i) {
            return <Column
              columnKey={value.key}
              header={<SortHeaderCell
                onSortChange={this._onSortChange}
                sortDir={this.state.colSortDirs[value.key]}
                style={{ whiteSpace: "nowrap" }}>{value.name}</SortHeaderCell>}

              // cell={({ rowIndex, ...props }) => (<Cell style={{ whiteSpace: "nowrap" }} >{this.props.seisan_follow_list[rowIndex][value.key]}</Cell>)}
              cell={({ rowIndex, ...props }) => (

                value.key === "room_name" ? <RoomName column={value} props={this.props} rowIndex={rowIndex}></RoomName>
                 : value.key === "kuushitsu_joukyou_name" ? <KuushitsuJoukyou column={value} props={this.props} rowIndex={rowIndex}></KuushitsuJoukyou>
                 : value.key === "kaiyaku_date" ? <KaiyakuDate column={value} props={this.props} rowIndex={rowIndex}></KaiyakuDate>
                 : value.key === "kagiban_setti_date" ? <KagibanSettiDate column={value} props={this.props} rowIndex={rowIndex}></KagibanSettiDate>
                 : value.key === "kagiban_tekkyo_date" ? <KagibanTekkyoDate column={value} props={this.props} rowIndex={rowIndex}></KagibanTekkyoDate>
                 : value.key === "io_keiyaku_date" ? <IoKeiyakuDate column={value} props={this.props} rowIndex={rowIndex}></IoKeiyakuDate>
                 : value.key === "tenpo_name_short" ? <TantouTenpo column={value} props={this.props} rowIndex={rowIndex}></TantouTenpo>
                 : value.key === "hoshuu_date" ? <HoshuuDate column={value} props={this.props} rowIndex={rowIndex}></HoshuuDate>
                 : value.key === "completion_at" ? <CompletionAt column={value} props={this.props} rowIndex={rowIndex}></CompletionAt>
                  : <Detail column={value} props={this.props} rowIndex={rowIndex} contract_follow_editer={this.contract_follow_editer}></Detail>
              )}

              width={columns.filter(a => a.key === value.key)[0].width}
              isResizable={true}
              fixed={value.frozen}

            />
          }, this)}

        </Table >

      </div>
    )
  }

}


// }

const mapStateToProps = (state) => {
  return {
    map_room_details_all: state.mapsearch.map_room_details_all,


  }
}
function mapDispatchToProps(dispatch) {
  return {
    change_map_room_details_all(state) {
        dispatch(MapSearch.change_map_room_details_all(state))
    },


  };
}

export default connect(mapStateToProps, mapDispatchToProps)(App);